import { MoneyBackIcon } from "@xola/icons";
import { almostZero } from "@xola/ui-kit";
import { isStoreCreditPurchaseItem } from "common";
import React from "react";
import { LineItem, LineItemObject, Purchase, PurchaseItem } from "types";
import { Currency } from "../../../Common/Currency";
import { TimelineItem } from "../TimelineItem";

interface FundsReversedTimelineItemProps {
    purchase: Purchase;
    item: PurchaseItem;
    lineItem: LineItem;
    showDate?: boolean;
}

export const FundsReversedTimelineItem = ({
    lineItem,
    purchase,
    item,
    showDate = false,
}: FundsReversedTimelineItemProps) => {
    if (
        !isStoreCreditPurchaseItem(item) &&
        !FundsReversedTimelineItem.supportsAudit(purchase, item, lineItem) &&
        !lineItem
    ) {
        return null;
    }

    const amount = getAmount(lineItem);

    return (
        <TimelineItem
            title="Funds Reversed"
            audit={lineItem}
            icon={<MoneyBackIcon />}
            color="danger"
            showDate={showDate}
            purchase={purchase}
        >
            <div className="flex flex-col space-y-2">
                <Currency shouldRemoveTrailingZeroes={false}>{amount}</Currency>
            </div>
        </TimelineItem>
    );
};

FundsReversedTimelineItem.supportsAudit = (_purchase: Purchase, _item: PurchaseItem, lineItem: LineItem) => {
    const amount = getAmount(lineItem);
    return !almostZero(amount);
};

const getAmount = (lineItem: LineItem): number => {
    if (lineItem.object === LineItemObject.REFUND && "fundingSource" in lineItem && lineItem.amount) {
        return lineItem.amount;
    }

    return 0;
};
